import React from 'react'
import styles from './index.module.scss'
import Menu from '@/layout/menu'
import Main from '../main/index'
import { ConfigProvider, Dropdown, Menu as AntdMenu } from 'antd'
import useInitHistroy from '@/hooks/use-init-histroy'
import { observer } from 'mobx-react'
import { useI18nStore } from '@/i18n/i18n-store'
import EntryLogo from '@/components/entryLogo'
import LoginModal from '@/components/login-modal'
import { $t } from '@/i18n/intl'
import { initAuthStatus, processLogout } from '@/business/login'
import { getStores } from '@/stores'
import useWsPollingFallback from '@/hooks/use-ws-polling-fallback'

const Container = () => {
  return (
    <div className="y-flex">
      <Menu />
      <Main />
    </div>
  )
}

const AIAgentEntry = () => {
  const { antdLocale } = useI18nStore()
  const { userStore } = getStores()
  const [showContent, setShowContent] = React.useState(false)

  React.useEffect(() => {
    initAuthStatus()
  }, [])

  useInitHistroy({
    autofetch: !userStore.showLoginModal
  })
  useWsPollingFallback()

  const logout = async () => {
    try {
      await processLogout()
      setShowContent(false)
    } catch (err) {
      console.error(err)
    }
  }

  const userMenu = (
    <AntdMenu>
      <AntdMenu.Item onClick={() => logout()}>{$t('system.head.logout')}</AntdMenu.Item>
    </AntdMenu>
  )

  return (
    <ConfigProvider
      locale={antdLocale}
      theme={{
        token: {
          colorPrimary: '#1E36E5'
        }
      }}
    >
      <div className={styles.container} id="agent">
        <LoginModal />

        {!userStore.showLoginModal && (
          <>
            <Dropdown
              arrow={false}
              dropdownRender={() => userMenu}
              overlayStyle={{ marginTop: '10px' }}
              placement="bottomLeft"
            >
              <div className={styles.beta}>Beta</div>
            </Dropdown>

            {!showContent && <EntryLogo onVisibleChange={() => setShowContent(true)} />}
            {showContent && <Container />}
          </>
        )}
      </div>
    </ConfigProvider>
  )
}

export default observer(AIAgentEntry)
